import React from 'react';
import Alert from '../../Components/Alert';
import Button from '../../Components/Button/Button';
import { useGrants } from '../../Data/Business';
import { useSession } from '../../Components/Session';

const AssigneesNotice = ({assignees, setAssignedTo}) => {
    const {activeGrants} = useGrants();
    const {user} = useSession();

    const others = assignees
        .filter(userId => userId !== null && userId !== user?.id)
        .map(userId => activeGrants?.find(g => g.userId === userId))
        .filter(Boolean);

    if (others.length === 0) {
        return null;
    }

    const names = new Intl.ListFormat('en-GB').format(others.map(g => g.title));

    if (assignees.length === 1) {
        return <Alert theme="info" message={`${names} will see this order.`} />;
    }

    return <Alert
        theme="warning"
        message={`${names} won't see this order. They only see an order made for their own jobs.`}
        buttons={others.map(grant => <Button
            key={grant.userId}
            theme="secondary"
            label={`Show ${grant.title}'s jobs`}
            onClick={() => setAssignedTo(grant.userId)}
        />)}
    />;
}

export default AssigneesNotice;
